import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {merge, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {catchError, startWith, switchMap} from 'rxjs/operators';
import {MatDialog, MatPaginator, MatSort} from '@angular/material';
import {AuthenticationService} from '../../../authentication.service';
import {HttpClient} from '@angular/common/http';
import {teamsService} from '../teams.service';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';
import {JoinTeamModalComponent} from '../join-team-modal/join-team-modal.component';


@Component({
  selector: 'elastic-teams-list',
  templateUrl: './teams-list.component.html',
  styleUrls: ['./teams-list.component.scss']
})
export class TeamsListComponent implements AfterViewInit {

  constructor(
    private cdr: ChangeDetectorRef,
    private auth: AuthenticationService,
    private dialog: MatDialog,
    private http: HttpClient,
    private teamsService: teamsService
  ) {

  }

  displayedColumns: string[] = ['#', 'logo', 'teamname', 'members', 'elo_acc', 'elo_ac', 'elo_ams2', 'safety_rating', 'leader', 'action'];
  filteredAndPagedTeams: Observable<any>;
  teamsearch = '';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  // @ts-ignore
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;


  ngAfterViewInit() {

    if (!this.auth.isLoggedIn()) {
      this.auth.redirectToLogin();
    } else {
      this.filteredAndPagedTeams = merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isLoadingResults = true;
            return this.getTeams(
              this.sort.active, this.sort.direction, this.paginator.pageIndex);
          }),
          map(data => {
            // Flip flag to show that loading has finished.
            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = data.total_count;
            return data.items;
          })
        );
    }

  }

  resetPaging(): void {
    this.paginator.pageIndex = 0;
  }

  getTeams(sort, direction, page): Observable<any> {
    return this.teamsService.getTeams(sort, direction, page);
  }

  joinTeam(team) {
    this.dialog.open(JoinTeamModalComponent, {
      data: {team}
    }).afterClosed().subscribe(resp => {
      if (resp) {
        //console.log(resp);
        this.getTeams(this.sort.active, this.sort.direction, this.paginator.pageIndex);
      }
    });
  }

  leaveTeam() {
    if (confirm("Do you really want to leave that team?")) {

    }
  }

  deleteTeam() {

  }
}
